import React from 'react';
import withSidebar from 'components/HOC/withSidebar';
import { ReportsTemplate } from '../components/templates/Reports/Reports.template';

const Reports: React.FC = () => (
  <React.StrictMode>
    <ReportsTemplate />
  </React.StrictMode>
);

export default withSidebar(Reports, true);
